
import Http from './Http'
import Security from './Security';
import data from "bootstrap/js/src/dom/data";

export default {
    async getBusinessWall() {
        return await Http.get(`business/wall`)
    },
    async updateBusinessWall(company_id,data){
        // let sanitizedData = Security.sanitizeObject(data)
        return  await  Http.patch(`business/wall/${company_id}`,data)
    },
    async updateBusinessCompany(company_id, data) {
        return await Http.patch(`/business/companies/${company_id}`, data);
    },
    async addBusinessUsers(data) {
        return await Http.post(`/business/users`, data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async addBusinessUsersFromExternalProvider(data) {
        return await Http.post(`/business/users/externalProvider`, data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async getBusinessMembers(){
        return await Http.get(`business/companies/members`)
    },

    async getExternalProvider(email){
        return await Http.get(`/business/companies/members/externalProvider?email=${email}`)
    },
    async attachExternalProvider(data){
        return await Http.patch(`/business/companies/members/attach`,data)
    },

    async detachExternalProvider(data){
        return await Http.patch(`/business/companies/members/detach`,data)
    },

    async removeBusinessCompanyAssets(data){
        return await Http.delete(`/business/companies/assets`, {
            params: data
        })
    },

    async getBusinessAssets(data){
        return await Http.get(`/business/assets?${data}`)
    },

    async addBusinessCompanyAssets(data){
        return await Http.post(`/business/companies/assets`,data)
    },

    async getBusinessUsers(params) {
        return await Http.get(`business/users`, { params });
    },
    async getCustomerB2BMatchTickets(data) {
        return await Http.get(`/business/users/matchTickets?${data}`)
    },
    async getCustomerB2BSeasonTickets(data) {
        return await Http.get(`/business/users/seasonTickets?${data}`)
    },

    async createBusinessLink(formData) {
        return await Http.post(`/business/link`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    async addCompanyToBusinessWall(data) {
        return await Http.post(`/business/wall`, data)
    },
    async editBusinessMember(customer_id, data) {
        return await Http.post(`/business/users/${customer_id}`, data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async updateUserReservations(event_id, data) {
        return await Http.patch(
            `/business/event/${event_id}/register`,
            data
        );
    },
    async registerBusinessEventMember(event_id, data) {
        return await Http.post(`/business/event/${event_id}/register`, data);
    },
    async attachUserToCompany(data){
        return await Http.post(`business/companies/members`,data)
    },
    async deleteCompanyFromBusinessWall(company_id){
        return await Http.delete(`/business/wall/${company_id}`)
    },

    async deleteBusinessUser(customer_id){
        return await Http.delete(`/business/users/${customer_id}`)
    },
    async deleteBusinessEventReservation(event_id,customer_id){
        return await Http.delete(`/business/event/${event_id}/unregister`,{ data: { customer_id } })
    },


    async deleteBusinessLink(id) {
        return await Http.delete(`/business/link/${id}`)
    },
    async bulkOnboardingEmail(data) {
        return await Http.post(`/business/users/bulkOnboardingEmail`, data);
    },
}


